import { _decorator, v4, SpriteFrame, v3 } from 'cc';
import ShaderManipulator from '../../Shader/ShaderManipulator';
import { IVapData, IVapSourceData, IVapSrcFrameData } from '../Data/VapData';

const { ccclass } = _decorator;

@ccclass('VapVideoMixComponent')
export default class VapVideoMixComponent extends ShaderManipulator {
    private _vapData: IVapData = null;
    private _vapSourceData: IVapSourceData = null;
    private _vapSrcFrameDatas: IVapSrcFrameData[] = [];
    private _currentFrameData: IVapSrcFrameData = null;

    protected get vapSourceData(): IVapSourceData {
        return this._vapSourceData;
    }

    public bindVideoTexture(spriteFrame: SpriteFrame) {
        this.targetPass.bindTexture(this.targetPass.getBinding('videoTexture'), spriteFrame.texture.getGFXTexture());
        this.targetPass.bindSampler(this.targetPass.getBinding('videoTexture'), spriteFrame.texture.getGFXSampler());
    }

    public setVapData(vapData: IVapData, srcId: string) {
        this._vapData = vapData;
        this._vapSourceData = this._vapData.src.find((src) => src.srcId === srcId);
        this._vapSrcFrameDatas = this._vapData.frame
            .map((frame) => ({
                i: frame.i,
                obj: frame.obj.filter((obj) => obj.srcId === srcId),
            }))
            .filter((frame) => frame.obj.length > 0);
    }

    public updateFrameData(currentTime: number) {
        const newFrameData = this._vapSrcFrameDatas.find((frameData) => this._timeToFrame(currentTime) === frameData.i);
        if (this._currentFrameData === newFrameData) {
            return;
        }
        this._currentFrameData = newFrameData;
        this._onCurrentFrameDataChanged();
    }

    protected syncProperty(): void {
        this._onCurrentFrameDataChanged();
    }

    private _onCurrentFrameDataChanged() {
        if (!this._currentFrameData) {
            this.node.opacity = 0;
            return;
        }
        this.node.opacity = 255;

        // material
        const data = this._currentFrameData.obj[0];
        this.targetPass.setUniform(this.targetPass.getHandle('alphaFrameArea'), v4(...data.mFrame));
        this.targetPass.setUniform(this.targetPass.getHandle('videoWidth'), this._vapData.info.videoW);
        this.targetPass.setUniform(this.targetPass.getHandle('videoHeight'), this._vapData.info.videoH);

        // position
        const [x, y, w, h] = data.frame;
        this.node.transform.setContentSize(w, h);
        const centerX = x + w / 2 - this._vapData.info.w / 2;
        const centerY = -(y + h / 2 - this._vapData.info.h / 2);
        this.node.setPosition(v3(centerX, centerY, 0));
    }

    private _timeToFrame(currentTime: number): number {
        return Math.floor(currentTime * this._vapData.info.fps);
    }
}
